export default __webpack_public_path__ + "static/media/game-dev.7e1a6c88.svg";